'use strict';
var util = require('../util');

module.exports = {
  appVersion: '8.0.6',

  share: function(opts) {
    //直接分享渠道计数从1开始
    if (opts.shareType !== undefined) {
      if (util.osName === 'android') {
        //Android下兼容shareType从1开始计数
        opts.shareType += 1;
      }
    }
    opts.feed = this._parseFeed(opts.feed);
    opts.url = this._tidyUrlParams(opts.url);
    
    this._send('share', opts);
  }

};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/dpapp/lib/patch/patch-8.0.6.js
// module id = 333
// module chunks = 1 12 14